/**
 * 採用ATS（HRMOS）リンク一覧
 *
 * 求人URLの変更は、このファイルのみを更新してください。
 */

const HRMOS_JOBS_BASE = 'https://hrmos.co/pages/flaretech-inc/jobs';

export const CAREER_LINKS = {
  allJobs: {
    label: '募集一覧（全職種）',
    usedIn: [
      'Header / Footer の Entry ボタン',
      'HomePage / NewGraduatePage ヒーロー Entry ボタン',
      'CTAButtons「募集要項を見る」',
      'HiringBanner / seedData',
      'TableOfContents「募集要項・エントリー」',
      'NewGraduatePage ジョブカード Entry ボタン',
    ],
    url: HRMOS_JOBS_BASE,
  },
  casualInterview: {
    label: 'カジュアル面談',
    usedIn: ['CasualCTA'],
    url: `${HRMOS_JOBS_BASE}/0000037`,
  },

  // エンジニア系（中途）
  developmentEngineer: {
    label: '開発エンジニア',
    usedIn: ['HomePage ジョブカード / 職種一覧'],
    url: `${HRMOS_JOBS_BASE}/0000001`,
  },
  infrastructureEngineer: {
    label: 'インフラエンジニア',
    usedIn: ['HomePage ジョブカード / 職種一覧'],
    url: `${HRMOS_JOBS_BASE}/0000002`,
  },
  dxEngineer: {
    label: 'DXエンジニア',
    usedIn: ['HomePage ジョブカード / 職種一覧'],
    url: `${HRMOS_JOBS_BASE}/0000003`,
  },

  // コーポレート系（中途）
  marketer: {
    label: 'マーケター職',
    usedIn: ['HomePage 職種一覧 Corporate & HR'],
    url: `${HRMOS_JOBS_BASE}/0000023`,
  },
  managementDirector: {
    label: '管理部長',
    usedIn: ['HomePage 職種一覧 Corporate & HR'],
    url: `${HRMOS_JOBS_BASE}/0000013`,
  },
  hr: {
    label: '人事担当',
    usedIn: ['HomePage 職種一覧 Corporate & HR'],
    url: `${HRMOS_JOBS_BASE}/0000021`,
  },
  accounting: {
    label: '経理担当',
    usedIn: ['HomePage 職種一覧 Corporate & HR'],
    url: `${HRMOS_JOBS_BASE}/0000033`,
  },

  // 新卒
  salesInternship: {
    label: '営業長期インターンシップ',
    usedIn: [
      'HomePage 職種一覧 新卒採用',
      'Header / Footer / NewGraduatePage の新卒ボタン（NEW_GRADUATE_URL）',
      'NewGraduatePage 長期インターン Entry',
      '/newgraduate/internship の TOC・エントリーはこちら',
    ],
    url: 'https://public.n-ats.hrmos.co/flaretech/jobs/2309646123603824640?src=4db80e44-3afa-4823-8845-ef5af51c4c7b',
  },
  newGradEngineer: {
    label: '［新卒2028］エンジニア',
    usedIn: ['NewGraduatePage 職種カード（エンジニア系）/ Internship', 'CasualCTA（/newgraduate のみ）'],
    url: 'https://public.n-ats.hrmos.co/flaretech/jobs/2306737066519449600?src=05c70c85-d279-4e83-8e7a-d0edeb6bb96b',
  },
  newGradSales: {
    label: '［新卒2028］営業職',
    usedIn: ['NewGraduatePage 職種カード（営業）/ Internship', 'CasualCTA（/newgraduate のみ）'],
    url: 'https://public.n-ats.hrmos.co/flaretech/jobs/2306764237673746432?src=827daebf-8c63-4b3f-b0a5-47db4ce1e890',
  },
};

export const getCareerLink = (key) => CAREER_LINKS[key]?.url ?? '';

export const ALL_JOBS_URL = CAREER_LINKS.allJobs.url;
export const CASUAL_INTERVIEW_URL = CAREER_LINKS.casualInterview.url;
export const DEVELOPMENT_ENGINEER_URL = CAREER_LINKS.developmentEngineer.url;
export const INFRASTRUCTURE_ENGINEER_URL = CAREER_LINKS.infrastructureEngineer.url;
export const DX_ENGINEER_URL = CAREER_LINKS.dxEngineer.url;
export const MARKETER_URL = CAREER_LINKS.marketer.url;
export const MANAGEMENT_DIRECTOR_URL = CAREER_LINKS.managementDirector.url;
export const HR_URL = CAREER_LINKS.hr.url;
export const ACCOUNTING_URL = CAREER_LINKS.accounting.url;
export const SALES_INTERNSHIP_URL = CAREER_LINKS.salesInternship.url;
export const NEW_GRAD_ENGINEER_URL = CAREER_LINKS.newGradEngineer.url;
export const NEW_GRAD_SALES_URL = CAREER_LINKS.newGradSales.url;

/** @deprecated Use SALES_INTERNSHIP_URL */
export const NEW_GRADUATE_URL = SALES_INTERNSHIP_URL;

const APPLY_URL_BY_JOB = {
  engineer: DEVELOPMENT_ENGINEER_URL,
  infra: INFRASTRUCTURE_ENGINEER_URL,
  dx: DX_ENGINEER_URL,
  sales: ALL_JOBS_URL,
  career: ALL_JOBS_URL,
  corporate: ALL_JOBS_URL,
  newgrad: SALES_INTERNSHIP_URL,
};

export const getApplyUrl = (job) => APPLY_URL_BY_JOB[job] || ALL_JOBS_URL;

export const INTERNSHIP_PAGE_PATH = '/newgraduate/internship';

export const isInternshipPagePath = (pathname = '') =>
  String(pathname).split('?')[0].replace(/\/$/, '') === INTERNSHIP_PAGE_PATH;

const LEGACY_SALES_INTERNSHIP_URL = `${HRMOS_JOBS_BASE}/0000039`;

/** Point intern-page apply hrefs at the current sales-intern listing (covers live CMS until re-seed). */
export function rewriteInternshipApplyLinks(html) {
  if (typeof html !== 'string' || !html) return html;
  return html
    .split(LEGACY_SALES_INTERNSHIP_URL).join(SALES_INTERNSHIP_URL)
    .split(ALL_JOBS_URL).join(SALES_INTERNSHIP_URL);
}
